import React, { useCallback, useEffect, useState } from "react";
import { Tag, Popover, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { apiRequests } from "src/shared/api/api";

const ContragentTags = ({ contragent, splitPoint = 2 }) => {
  const [tags, setTags] = useState([]);

  const findContragent = useCallback(async () => {
    try {
      const res = await apiRequests.contragents.getItems({
        phone: contragent.phone,
        add_tags: true,
      });

      if (res.data?.result?.length > 0) {
        setTags(res.data.result[0].tags || []);
      }
    } catch (error) {
      console.error("Ошибка при получении тегов контрагента:", error);
      setTags([]);
    }
  }, [contragent]);

  useEffect(() => {
    findContragent();
  }, [contragent, findContragent]);

  const visibleTags = tags.slice(0, splitPoint);
  const hiddenTags = tags.slice(splitPoint);

  const menu = (
    <Menu style={{ padding: 8, maxHeight: 300, overflowY: "auto" }}>
      {hiddenTags.map((tag) => (
        <Menu.Item key={tag.id}>
          <Popover title={tag.description}>
            <Tag color={tag.color || "default"}>
              {tag.emoji && `${tag.emoji} `}
              {tag.name}
            </Tag>
          </Popover>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
      {visibleTags.map((tag) => (
        <Popover key={tag.id} title={tag.description}>
          <Tag color={tag.color || "default"}>
            {tag.emoji && `${tag.emoji} `}
            {tag.name}
          </Tag>
        </Popover>
      ))}

      {hiddenTags.length > 0 && (
        <Dropdown overlay={menu} trigger={["click"]}>
          <Tag style={{ cursor: "pointer" }}>
            +{hiddenTags.length} ещё <DownOutlined style={{ fontSize: 10 }} />
          </Tag>
        </Dropdown>
      )}
    </div>
  );
};

export default ContragentTags;
